import React, { useState } from "react";
import "./Tabs.css";
import {
  Tabs as MuiTabs,
  Tab,
  Box,
  Popover,
  Dialog,
  DialogContent,
} from "@mui/material";
import DeletePartDialog from "../../modules/ConfigurationModule/components/PartsConfiguration/DeletePartDialog";

import { TabDialogConfiguration } from "./TabDialogConfiguration";

export function Tabs({
  tabs,
  activeTabId,
  onTabChange,
  onAddTab,
  onDeleteTab,
  onUpdateTab,
  onToggleFilterPanel,
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTabId, setSelectedTabId] = useState(null);
  const [isTabConfigDialogOpen, setIsTabConfigDialogOpen] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleTabConfiguration = () => {
    onTabOptionsClose();
    setIsTabConfigDialogOpen((prev) => !prev);
  };

  const handleOpen = () => {
    onTabOptionsClose();
    if (tabs.length <= 1) {
      alert("You can't delete the last tab");
      return;
    }
    setConfirmOpen(true);
  };
  const handleClose = () => setConfirmOpen(false);
  const handleConfirmDelete = () => {
    onDeleteTab(selectedTabId);
    handleClose();
  };

  const onChange = (_, newValue) => {
    if (newValue === "add") {
      onAddTab();
      return;
    }
    onTabChange(newValue);
  };

  const onTabOptionsClick = (event, tabId) => {
    event.stopPropagation();
    event.preventDefault();
    setSelectedTabId(tabId);
    setAnchorEl(event.currentTarget);
  };

  const onTabOptionsClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        sx={{
          // borderBottom: "1px solid #e0e0e0",
          display: "flex",
          alignItems: "center",
        }}
      >
        <MuiTabs
          value={activeTabId}
          onChange={onChange}
          variant="scrollable"
          scrollButtons="auto"
          className="dashboard-tab-group"
          aria-label="kodo tabs"
          sx={{
            "& .MuiTabs-flexContainer": { flexWrap: "nowrap" },
            overflowX: "auto",
            overflowY: "hidden",
          }}
        >
          {tabs.map((tab) => (
            <Tab
              className="dashboard-tab"
              key={tab.tabId}
              value={tab.tabId}
              label={
                tab.showTitleInUppercase ? tab.label.toUpperCase() : tab.label
              }
              icon={
                <Box
                  onClickCapture={(e) => onTabOptionsClick(e, tab.tabId)}
                  className="tab-icon-container"
                >
                  <span className="icon-more-vertical"></span>
                </Box>
              }
              iconPosition="end"
              id={`dashboard-${tab.tabId}`}
              aria-controls={`dashboard-${tab.tabId}`}
            />
          ))}
          {/* <Tab
            icon={<span className="icon-add-new" />}
            value="add"
            aria-label="Add Tab"
            className="add-new-dashboard-btn"
          /> */}
        </MuiTabs>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <button
            value="add"
            aria-label="Add Tab"
            className="add-new-dashboard-btn"
            onClick={onAddTab}
          >
            <span className="icon-add-new" />
          </button>

          <button
            value="filterPanel"
            aria-label="Add Filter Panel"
            className="add-filter-panel-btn"
            onClick={onToggleFilterPanel}
          >
            <span className="icon-Filter_manager" />
          </button>
        </div>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={onTabOptionsClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          PaperProps={{
            sx: {
              bgcolor: "background.paper",
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", minWidth: 160 }}>
            <Box
              component="button"
              onClick={handleTabConfiguration}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 1.5,
                pb: "8px",
                gap: 1,
                fontSize: "0.6rem",
                textAlign: "left",
                bgcolor: "transparent",
                border: "none",
                width: "100%",
                cursor: "pointer",
                "&:hover": {
                  bgcolor: "action.hover",
                },
              }}
            >
              <span className="icon-tab-config icon-tab-dashboard"></span>
              Tab Configuration
            </Box>
            <Box
              component="button"
              onClick={handleOpen}
              disabled={tabs.length <= 1}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 1.5,
                pt: "8px",
                gap: 1,
                fontSize: "0.6rem",
                textAlign: "left",
                bgcolor: "transparent",
                border: "none",
                width: "100%",
                cursor: tabs.length <= 1 ? "not-allowed" : "pointer",
                "&:hover": {
                  bgcolor: tabs.length <= 1 ? "transparent" : "action.hover",
                },
              }}
            >
              <span className="icon-trash icon-tab-dashboard"></span>
              Delete Tab
            </Box>
          </Box>
        </Popover>
      </Box>
      <Dialog
        open={confirmOpen}
        onClose={handleClose}
        BackdropProps={{ style: { backdropFilter: "blur(4px)" } }}
      >
        <DialogContent>
          <DeletePartDialog
            message="Are you sure you want to delete this tab?"
            onClose={handleClose}
            onDelete={handleConfirmDelete}
          />
        </DialogContent>
      </Dialog>
      {isTabConfigDialogOpen && (
        <TabDialogConfiguration
          isOpen={isTabConfigDialogOpen}
          onClose={() => setIsTabConfigDialogOpen(false)}
          onUpdateTab={onUpdateTab}
          selectedTab={tabs.find((tab) => tab.tabId === selectedTabId)}
        />
      )}
    </>
  );
}
